import * as glovoMenuApi from "../endpoints/glovoMenu";

// ============ SUPER COLLECTIONS ============

export async function try_GetSuperCollections(storeAddressId) {
  try {
    const response = await glovoMenuApi.getSuperCollections(storeAddressId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}

export async function try_DeleteSuperCollection(storeAddressId, superCollectionId) {
  try {
    const response = await glovoMenuApi.deleteSuperCollection(storeAddressId, superCollectionId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}

// ============ COLLECTIONS ============

export async function try_GetCollections(storeAddressId) {
  try {
    const response = await glovoMenuApi.getCollections(storeAddressId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}

export async function try_DeleteCollection(storeAddressId, collectionId) {
  try {
    const response = await glovoMenuApi.deleteCollection(storeAddressId, collectionId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}

// ============ PRODUCTS ============

export async function try_GetProducts(storeAddressId) {
  try {
    const response = await glovoMenuApi.getProducts(storeAddressId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}

export async function try_DeleteProduct(storeAddressId, groupId, productId) {
  try {
    const response = await glovoMenuApi.deleteProduct(storeAddressId, groupId, productId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}

export async function try_DeleteProductGroup(storeAddressId, groupId) {
  try {
    const response = await glovoMenuApi.deleteProductGroup(storeAddressId, groupId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}

// ============ OPTIONS ============

export async function try_GetOptions(storeAddressId) {
  try {
    const response = await glovoMenuApi.getOptions(storeAddressId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}

export async function try_DeleteOptionGroup(storeAddressId, groupId) {
  try {
    const response = await glovoMenuApi.deleteOptionGroup(storeAddressId, groupId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}

export async function try_DeleteOption(storeAddressId, groupId, optionId) {
  try {
    const response = await glovoMenuApi.deleteOption(storeAddressId, groupId, optionId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}

// ============ CLEAR ALL MENU ============

export async function try_ClearAllMenu(storeAddressId) {
  try {
    const response = await glovoMenuApi.clearAllMenu(storeAddressId);
    return response.data;
  } catch (error) {
    console.error("[Glovo Menu Service Error]:", error);
    throw error;
  }
}
